(function () {
    /**
     * Handrails calculator
     * 
     * Original supplied for us, amended slightly to work with Shopify
     */
    const LOGO_SRC =
      window.HRD_LOGO_SRC ||
      "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/handrails-direct-logo.png?v=1750068288";
  
    const MIN = 250;
    const FULL = 1200;
  
    const FINISH_NAMES = {
      kineton: "Kineton Matt Black",
      edstone: "Edstone Matt White",
      loxley: "Loxley Antique Brass",
      harbury: "Harbury Brushed Silver",
      sambourne: "Sambourne Antique Copper",
      radway: "Radway Chrome",
      ashorne: "Ashorne Satin Brass",
      luddington: "Luddington Textured Grey",
    };
  
    const PRICES = {
      poles: "£15.00",
      supports: "£10.00",
      elbows: "£15.00",
      connectors: "£10.00",
      endcaps: "£5.00",
    };
  
    const GROUP_LABELS = {
      poles: "Handrail poles – maximum length 1.2m",
      supports: "For securing the handrail to the wall",
      elbows: "For the turns in the handrail",
      connectors: "For joining poles together",
      endcaps: "For a clean finish (2 end caps per pack)",
    };

    // Hard coded product data for the calculator
    // Potentially could pull this direct from Shopify later
    const PRODUCT_DATA = {
      kineton: {
        elbows: {
          name: "Kineton Matt Black Adjustable Elbow",
          sku: "HRIE01MB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-Black-Elbow.webp?v=1754040096",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-matt-black"
        },
        endcaps: {
          name: "Kineton Matt Black End Caps",
          sku: "HRIC01MB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01MB_01_7e08d316-8214-44ec-9377-0cb7b14921a9.webp?v=1771599046",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-matt-black"
        },
        connectors: {
          name: "Kineton Matt Black Connecting Bracket",
          sku: "HRCB01MB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-Black-Connecting-Bracket.webp?v=1754040201",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-matt-black"
        },
        supports: {
          name: "Kineton Matt Black Support Bracket",
          sku: "HRWB01MB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-Black-Support-Bracket.webp?v=1754040303",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-matt-black"
        },
        poles: {
          name: "Kineton Matt Black Handrail Pole 1.2 Metre",
          sku: "HRRL1200MB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200MB_01.png?v=1771598293",
          url: "https://www.handrails-direct.co.uk/products/rail-matt-black"
        }
      },
      edstone: {
        elbows: {
          name: "Edstone Matt White Adjustable Elbow",
          sku: "HRIE01MW",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-White-Elbow.webp?v=1754040061",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-matt-white"
        },
        endcaps: {
          name: "Edstone Matt White End Caps",
          sku: "HRIC01MW",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01MW_01_dd36275a-6c1f-49fc-aa85-25d4bcc166c3.webp?v=1771599020",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-matt-white"
        },
        connectors: {
          name: "Edstone Matt White Connecting Bracket",
          sku: "HRCB01MW",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-White-Connecting-Bracket.webp?v=1754040185",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-matt-white"
        },
        supports: {
          name: "Edstone Matt White Support Bracket",
          sku: "HRWB01MW",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Matt-White-Support-Bracket_90632ce4-e577-4c20-af06-ef5c69148f69.webp?v=1754040286",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-matt-white"
        },
        poles: {
          name: "Edstone Matt White Handrail Pole 1.2 Metre",
          sku: "HRRL1200MW",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200MW_01.png?v=1771598316",
          url: "https://www.handrails-direct.co.uk/products/rail-matt-white"
        }
      },
      harbury: {
        elbows: {
          name: "Harbury Brushed Silver Adjustable Elbow",
          sku: "HRIE01BS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Brushed-Elbow.webp?v=1754040099",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-brushed"
        },
        endcaps: {
          name: "Harbury Brushed Silver End Caps",
          sku: "HRIC01BS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01BS_01_edfcdf01-b500-4f10-bf6d-4b32b4e963af.webp?v=1771599355",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-brushed"
        },
        connectors: {
          name: "Harbury Brushed Silver Connecting Bracket",
          sku: "HRCB01BS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Brushed-Silver-Connecting-Bracket.webp?v=1754040214",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-brushed"
        },
        supports: {
          name: "Harbury Brushed Silver Support Bracket",
          sku: "HRWB01BS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Brushed-Silver-Support-Bracket.webp?v=1754040320",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-brushed"
        },
        poles: {
          name: "Harbury Brushed Silver Handrail Pole 1.2 Metre",
          sku: "HRRL1200BS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200BS_01_9da2a71c-758f-45d2-a5c7-68c730623edc.png?v=1771598274",
          url: "https://www.handrails-direct.co.uk/products/rail-brushed"
        }
      },
      loxley: {
        elbows: {
          name: "Loxley Antique Brass Adjustable Elbow",
          sku: "HRIE01AB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Antique-Brass-Elbow.webp?v=1754040113",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-antique-brass"
        },
        endcaps: {
          name: "Loxley Antique Brass End Caps",
          sku: "HRIC01AB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01AB_01_5b85e8ea-f315-401c-8cd8-5bb69da3dfdd.webp?v=1771599228",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-antique-brass"
        },
        connectors: {
          name: "Loxley Antique Brass Connecting Bracket",
          sku: "HRCB01AB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Antique-Brass-Connecting-Bracket.webp?v=1754040233",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-antique-brass"
        },
        supports: {
          name: "Loxley Antique Brass Support Bracket",
          sku: "HRWB01AB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/Antique-Brass-Support-Bracket.webp?v=1754040336",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-antique-brass"
        },
        poles: {
          name: "Loxley Antique Brass Handrail Pole 1.2 Metre",
          sku: "HRRL1200AB",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200AB_01.png?v=1771598173",
          url: "https://www.handrails-direct.co.uk/products/rail-antique-brass"
        }
      },
      sambourne: {
        elbows: {
          name: "Sambourne Antique Copper Adjustable Elbow",
          sku: "HRIE01AC",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIE01AC_01.webp?v=1771425391",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-antique-copper"
        },
        endcaps: {
          name: "Sambourne Antique Copper End Caps",
          sku: "HRIC01AC",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01AC_01_6dfdb6f8-fd83-4a6c-a855-a20f2dfb1a9f.webp?v=1771599005",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-antique-copper"
        },
        supports: {
          name: "Sambourne Antique Copper Support Bracket",
          sku: "HRWB01AC",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRWB01AC_01.webp?v=1771424597",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-antique-copper"
        },
        poles: {
          name: "Sambourne Antique Copper Handrail Pole 1.2 Metre",
          sku: "HRRL1200AC",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200AC_01.png?v=1771598350",
          url: "https://www.handrails-direct.co.uk/products/rail-antique-copper"
        },
        connectors: {
          name: "Sambourne Antique Copper Connecting Bracket",
          sku: "HRCB01AC",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRCB01AC_01.webp?v=1771423916",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-antique-copper"
        }
      },
      radway: {
        elbows: {
          name: "Radway Chrome Adjustable Elbow",
          sku: "HRIE01PS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIE01PS_01.webp?v=1771425624",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-chrome"
        },
        endcaps: {
          name: "Radway Chrome End Caps",
          sku: "HRIC01PS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01PS_01_4431ebc2-4978-4464-8816-24601502db3a.webp?v=1771598904",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-chrome"
        },
        supports: {
          name: "Radway Chrome Support Bracket",
          sku: "HRWB01PS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRWB01PS_01.webp?v=1771424458",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-chrome"
        },
        poles: {
          name: "Radway Chrome Handrail Pole 1.2 Metre",
          sku: "HRRL1200PS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200PS_01.png?v=1771598429",
          url: "https://www.handrails-direct.co.uk/products/rail-chrome"
        },
        connectors: {
          name: "Radway Chrome Connecting Bracket",
          sku: "HRCB01PS",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRCB01PS_01.webp?v=1771423830",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-chrome"
        }
      },
      ashorne: {
        elbows: {
          name: "Ashorne Satin Brass Adjustable Elbow",
          sku: "HRIE01BR",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIE01BR_01.webp?v=1771425487",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-satin-brass"
        },
        endcaps: {
          name: "Ashorne Satin Brass End Caps",
          sku: "HRIC01BR",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01BR_01_3948c2cb-92f7-4a3e-993f-252adc0b9c6b.webp?v=1771598968",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-satin-brass"
        },
        supports: {
          name: "Ashorne Satin Brass Support Bracket",
          sku: "HRWB01BR",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRWB01BR_01.webp?v=1771424892",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-satin-brass"
        },
        poles: {
          name: "Ashorne Satin Brass Handrail Pole 1.2 Metre",
          sku: "HRRL1200BR",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200BR_01.png?v=1771598371",
          url: "https://www.handrails-direct.co.uk/products/rail-satin-brass"
        },
        connectors: {
          name: "Ashorne Satin Brass Connecting Bracket",
          sku: "HRCB01BR",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRCB01BR_01.webp?v=1771426636",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-satin-brass"
        }
      },
      luddington: {
        elbows: {
          name: "Luddington Textured Grey Adjustable Elbow",
          sku: "HRIE01TG",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIE01TG_01.webp?v=1771425578",
          url: "https://www.handrails-direct.co.uk/products/adj-elbow-internal-fit-textured-grey"
        },
        endcaps: {
          name: "Luddington Textured Grey End Caps",
          sku: "HRIC01TG",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRIC01TG_01_2241252e-a5b9-4905-9ddd-1f14f0d0086b.webp?v=1771598920",
          url: "https://www.handrails-direct.co.uk/products/end-caps-internal-fit-textured-grey"
        },
        supports: {
          name: "Luddington Textured Grey Support Bracket",
          sku: "HRWB01TG",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRWB01TG_01.webp?v=1771424544",
          url: "https://www.handrails-direct.co.uk/products/support-bracket-textured-grey"
        },
        poles: {
          name: "Luddington Textured Grey Handrail Pole 1.2 Metre",
          sku: "HRRL1200TG",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRRL1200TG_01.png?v=1771598400",
          url: "https://www.handrails-direct.co.uk/products/rail-textured-grey"
        },
        connectors: {
          name: "Luddington Textured Grey Connecting Bracket",
          sku: "HRCB01TG",
          image: "https://cdn.shopify.com/s/files/1/0913/2864/3447/files/HRCB01TG_01.webp?v=1771423968",
          url: "https://www.handrails-direct.co.uk/products/connecting-bracket-textured-grey"
        }
      }
    };

    /**
     * We allow init to run again in Shopify theme editor reloads,
     * but we avoid binding duplicate listeners to the same DOM.
     */
    function initCalculator() {
      const root = document;
      const byId = (id) => root.getElementById(id);
  
      // Core elements. If these do not exist, this script should do nothing.
      const turnsEl = byId("turns");
      const totalEl = byId("totalLength");
      const turnCountEl = byId("turnCount");
      const calcBtn = byId("calc");
      const inputsSection = byId("inputsSection");
      const resultsSection = byId("results");
      const editBtn = byId("edit");
      const segmentInfo = byId("segmentInfo");
      const materialsEl = byId("materials");
      const finishGrid = byId("finishGrid");
  
      // PDF / preview elements
      const pdfPreviewEl = byId("pdfPreview");
      const pdfDocEl = byId("pdfDocument");
      const closePreviewBtn = byId("closePreview");
      const printPdfBtn = byId("printPdf");
      const savePdfBtn = byId("savePdf");
      const downloadPdfBtn = byId("downloadPdfBtn");
  
      // Cart buttons
      const addToCartTop = byId("addToCartTop");
      const addToCartBottom = byId("addToCartBottom");
  
      const getPrintStaging = () => byId("printStaging");
  
      // If the calculator isn't present on this page, stop quietly.
      if (
        !turnsEl ||
        !totalEl ||
        !turnCountEl ||
        !calcBtn ||
        !inputsSection ||
        !resultsSection ||
        !editBtn ||
        !segmentInfo ||
        !materialsEl ||
        !finishGrid
      ) {
        return;
      }
  
      // Prevent duplicate initialization on same DOM.
      if (calcBtn.dataset.hrdBound === "true") {
        return;
      }
      calcBtn.dataset.hrdBound = "true";
  
      let lastQuote = null;
      let selectedFinish = "edstone";
      let turnCount = 0;

      let selectedVariants = [];

      let errorMessage = '';
  
      // -----------------------------
      // Helpers
      // -----------------------------
  
      function num(value) {
        return parseInt(String(value).replace(/[^0-9]/g, "") || "0", 10);
      }
  
      function fmt(n) {
        const s = (Math.round(n * 10) / 10).toFixed(1);
        return s.endsWith(".0") ? s.slice(0, -2) : s;
      }
  
      /**
       * Error/notice dialog — a centred modal the user must dismiss themselves
       * (click the close button, click the overlay, or press Escape), styled
       * to match the calculator's other popups (#lengthPopup / #turnsPopup).
       * Built with inline styles rather than Tailwind classes so it always
       * renders correctly regardless of what's compiled into the theme's CSS.
       */
      function getErrorModal() {
        let modal = document.getElementById("hrd-error-modal");
        if (modal) return modal;

        modal = document.createElement("div");
        modal.id = "hrd-error-modal";
        modal.setAttribute("role", "alertdialog");
        modal.setAttribute("aria-modal", "true");
        modal.style.cssText =
          "position:fixed;inset:0;z-index:10000;display:none;" +
          "align-items:center;justify-content:center;" +
          "background:rgba(0,0,0,.55);padding:16px;";

        const box = document.createElement("div");
        box.style.cssText =
          "position:relative;background:#ffffff;border-radius:8px;" +
          "box-shadow:0 24px 64px rgba(0,0,0,.25);width:min(440px,94vw);" +
          "padding:36px 28px 30px;text-align:center;" +
          "font-size:16px;line-height:1.5;color:#1a1a1a;";

        const closeBtn = document.createElement("button");
        closeBtn.type = "button";
        closeBtn.setAttribute("aria-label", "Close");
        closeBtn.textContent = "×";
        closeBtn.style.cssText =
          "position:absolute;right:16px;top:16px;width:26px;height:26px;" +
          "border:0;border-radius:999px;background:#01405C;color:#fff;" +
          "font-size:16px;line-height:1;cursor:pointer;padding:0;" +
          "display:flex;align-items:center;justify-content:center;";
        closeBtn.addEventListener("click", closeErrorModal);

        const icon = document.createElement("div");
        icon.style.cssText = "font-size:32px;margin-bottom:10px;";
        icon.innerHTML = "&#9888;&#65039;";

        const messageEl = document.createElement("div");
        messageEl.id = "hrd-error-modal-message";

        const okBtn = document.createElement("button");
        okBtn.type = "button";
        okBtn.textContent = "OK";
        okBtn.style.cssText =
          "margin-top:22px;padding:10px 28px;border:0;border-radius:999px;" +
          "background:#D8AE60;color:#01405C;font-weight:700;font-size:15px;" +
          "cursor:pointer;";
        okBtn.addEventListener("click", closeErrorModal);

        box.appendChild(closeBtn);
        box.appendChild(icon);
        box.appendChild(messageEl);
        box.appendChild(okBtn);
        modal.appendChild(box);

        // Click outside the box (on the dark overlay) also dismisses it.
        modal.addEventListener("click", (e) => {
          if (e.target === modal) closeErrorModal();
        });

        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && modal.style.display !== "none") {
            closeErrorModal();
          }
        });

        document.body.appendChild(modal);
        return modal;
      }

      function closeErrorModal() {
        const modal = document.getElementById("hrd-error-modal");
        if (modal) modal.style.display = "none";
      }

      function toast(message) {
        const modal = getErrorModal();
        const messageEl = document.getElementById("hrd-error-modal-message");
        if (messageEl) messageEl.textContent = message;
        modal.style.display = "flex";
      }
  
      function sanitiseNumericInput(input) {
        if (!input) return;
        input.value = input.value.replace(/[^0-9]/g, "");
      }
  
      // -----------------------------
      // Finish selection
      // -----------------------------
  
      finishGrid.querySelectorAll(".finish-item").forEach((item) => {
        if (item.dataset.hrdBound === "true") return;
        item.dataset.hrdBound = "true";
  
        item.addEventListener("click", () => {
          finishGrid
            .querySelectorAll(".finish-item")
            .forEach((i) => i.classList.remove("selected"));
  
          item.classList.add("selected");
          selectedFinish = item.dataset.finish;
        });
      });
  
      // -----------------------------
      // Turn stepper controls
      // -----------------------------
  
      const turnMinusBtn = byId("turnMinus");
      const turnPlusBtn = byId("turnPlus");
  
      if (turnMinusBtn && turnMinusBtn.dataset.hrdBound !== "true") {
        turnMinusBtn.dataset.hrdBound = "true";
        turnMinusBtn.addEventListener("click", () => {
          if (turnCount > 0) {
            turnCount--;
            turnCountEl.textContent = turnCount;
            syncTurnRows();
          }
        });
      }
  
      if (turnPlusBtn && turnPlusBtn.dataset.hrdBound !== "true") {
        turnPlusBtn.dataset.hrdBound = "true";
        turnPlusBtn.addEventListener("click", () => {
          if (num(totalEl.value) < 2 * MIN && turnCount === 0) {
            toast("Need at least 500mm total to add a turn.");
            return;
          }
  
          turnCount++;
          turnCountEl.textContent = turnCount;
          syncTurnRows();
        });
      }
  
      /**
       * Keep the number of rendered turn rows in sync with turnCount.
       */
      function syncTurnRows() {
        const rows = [...turnsEl.querySelectorAll(".turn-row")];
  
        while (rows.length > turnCount) {
          rows[rows.length - 1].remove();
          rows.pop();
        }
  
        while (turnsEl.querySelectorAll(".turn-row").length < turnCount) {
          addTurnRow(turnsEl.querySelectorAll(".turn-row").length + 1);
        }
      }
  
      /**
       * Adds one turn row, preserving the original UI copy and classes.
       */
      function addTurnRow(idx) {
        const row = document.createElement("div");
        row.className =
          "turn-row bg-cream-100 rounded-[10px] p-6 flex items-center gap-3 mb-2.5";
  
        row.innerHTML = `
          <span class="font-bold text-blue-500 text-[18px] whitespace-nowrap min-w-[52px]">Turn ${idx}</span>
          <p class="flex-1">What is the distance in mm before the turn?</p>
          <input
            class="turn-distance w-[108px] h-[42px] border border-gold-500 rounded-full px-3.5 text-[15px] font-body bg-white text-center outline-none flex-shrink-0 transition-colors duration-200 focus:border-brand-blue"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            placeholder="e.g. 1200"
          >
          <span class="text-[13px]">mm</span>
        `;
  
        const input = row.querySelector("input");
        if (input) {
          input.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
          });
        }
  
        turnsEl.appendChild(row);
      }
  
      // Keep total length numeric only
      if (totalEl.dataset.hrdBound !== "true") {
        totalEl.dataset.hrdBound = "true";
        totalEl.addEventListener("input", () => {
          sanitiseNumericInput(totalEl);
        });
      }
  
      // -----------------------------
      // Core calculation helpers
      // -----------------------------
  
      /**
       * Build the pole cut lengths for a given span.
       *
       * Rules retained from original script:
       * - Split across 1200mm max lengths
       * - Deduct 2.5mm from joined pieces on each side of a connector
       * - Deduct 25mm when an elbow is present at left/right edge
       * - Round to nearest 0.5mm
       */
      function buildPieces(spanLen, count, leftElbow, rightElbow) {
        if (count <= 0) return [];
  
        const pieces = Array(count).fill(spanLen / count);
        const isWhole = spanLen % FULL === 0  
  
        // Each internal join removes 5mm total, split across neighbouring poles.
        if (!isWhole) {  
          for (let j = 0; j < count - 1; j++) {
            pieces[j] -= 2.5;
            pieces[j + 1] -= 2.5;
          }
        }
  
        if (leftElbow) pieces[0] -= 25;
        if (rightElbow) pieces[count - 1] -= 25;
  
        return pieces.map((p) => Math.max(1, Math.round(p * 2) / 2));
      }
  
      /**
       * Validate all user inputs before calculation.
       *
       * Rules retained from original:
       * - total must be > 0
       * - each turn distance must be >= 250mm
       * - sum of turn distances cannot exceed total
       * - remaining final segment must also be >= 250mm when turns exist
       */
      function inputsValid() {
        // Default error message
        errorMessage = 'Please check lengths: each turn ≥ 250mm, total of turns ≤ total, and ≥ 250mm remaining.'

        const total = num(totalEl.value);
        if (total <= 0) return false;
        
        const totalTurns = turnsEl.querySelectorAll("input.turn-distance").length
        const vals = [...turnsEl.querySelectorAll("input.turn-distance")]
          .map((input) => num(input.value))
          .filter((v) => v > 0);

        if (totalTurns !== vals.length) {
          errorMessage = 'Values missing for turns. Please check each turn has a value entered.';
          return false;
        }
        
        if (vals.some((v) => v < MIN)) return false;
  
        const sum = vals.reduce((a, b) => a + b, 0);
        if (sum > total) return false;
  
        if (vals.length > 0 && total - sum < MIN) return false;
  
        return true;
      }
  
      // -----------------------------
      // Main calculation
      // -----------------------------
  
      function calculate() {
        sanitiseNumericInput(totalEl);
  
        [...turnsEl.querySelectorAll("input.turn-distance")].forEach((input) => {
          sanitiseNumericInput(input);
        });
  
        if (!inputsValid()) {
          toast(errorMessage);
          return;
        }
  
        const total = num(totalEl.value);
        const turnVals = [...turnsEl.querySelectorAll("input.turn-distance")]
          .map((input) => num(input.value))
          .filter((v) => v > 0);
  
        const hasTurns = turnVals.length > 0;
        const sum = turnVals.reduce((a, b) => a + b, 0);
        const remaining = total - sum;
  
        const materials = {
          poles: 0,
          supports: 2,
          elbows: turnVals.length,
          connectors: 0,
          endcaps: 1,
        };
  
        const spans = [];
  
        // Build each turn span
        turnVals.forEach((length, i) => {
          const count = Math.ceil(length / FULL);
          const pieces = buildPieces(length, count, i > 0, true);
  
          materials.poles += count;
          if (count > 1) materials.connectors += count - 1;
          materials.supports += 2;
  
          spans.push({
            i,
            length,
            pieces,
          });
        });
  
        // Build final span
        const finalLength = hasTurns ? remaining : total;
        const finalCount = Math.ceil(finalLength / FULL);
  
        if (finalCount > 0 || !hasTurns) {
          const finalPieces = buildPieces(finalLength, finalCount, hasTurns, false);
  
          materials.poles += finalCount;
          if (finalCount > 1) materials.connectors += finalCount - 1;
  
          spans.push({
            i: hasTurns ? turnVals.length : 0,
            length: finalLength,
            pieces: finalPieces,
          });
        }
  
        const finishText = FINISH_NAMES[selectedFinish] || selectedFinish;
  
        const ovTotal = byId("ov-total");
        const ovTurns = byId("ov-turns");
        const ovFinish = byId("ov-finish");
        const ovRemaining = byId("ov-remaining");
        const remainingRow = byId("remaining-row");
  
        if (ovTotal) ovTotal.textContent = total + "mm";
        if (ovTurns) ovTurns.textContent = turnVals.length;
        if (ovFinish) ovFinish.textContent = finishText;
        if (ovRemaining) ovRemaining.textContent = remaining + "mm";

        remainingRow.style.display = remaining == total ? 'none' : 'flex';
        
        // Render segment / pole cut results
        let poleCounter = 1;
  
        segmentInfo.innerHTML = spans
          .map((span, spanIndex) => {
            const cuts = span.pieces
              .map((piece) => {
                const html = `<div class="pole-cut"><span class="pole-bold">Pole ${poleCounter}</span> – Cut to ${fmt(piece)} mm</div>`;
                poleCounter++;
                return html;
              })
              .join("");
  
            return `
              <div class="segment-row">
                <span class="span-label">Span ${spanIndex + 1}</span>
                <div class="span-detail">
                  <div class="span-len">${span.length}mm</div>
                  ${cuts}
                </div>
              </div>
            `;
          })
          .join("");
  
        // Render materials list
        const data = selectedFinish in PRODUCT_DATA ? PRODUCT_DATA[selectedFinish] : PRODUCT_DATA["edstone"];
  
        materialsEl.innerHTML = ["poles", "supports", "elbows", "connectors", "endcaps"]
          .map((part) => {
            if (!materials[part]) return "";

            // Build items list to add to cart
            const sku = skuFor(selectedFinish, part)
            const variantId = window.variantIdBySku?.[sku];
            if (variantId) {
                selectedVariants.push({
                    id: variantId,
                    qty: materials[part]
                })
            }
  
            return `
              <div class="materials-group-label">${GROUP_LABELS[part]}</div>
              <a href="${data[part].url}" class="material-item" target="_blank">
                <div class="material-img"><img src="${data[part].image}&width=60" width="60" /></div>
                <div class="material-info">
                  <div class="material-name">${data[part].name}</div>
                  <div class="material-price">${PRICES[part]}</div>
                </div>
                <div class="material-qty">Quantity: ${materials[part]}</div>
              </a>
            `;
          })
          .join("");
  
        lastQuote = {
          total,
          turns: turnVals.length,
          remaining,
          finish: finishText,
          finishKey: selectedFinish,
          materials: { ...materials },
          spans,
        };
  
        if (pdfDocEl) {
          pdfDocEl.dataset.stale = "1";
        }
  
        inputsSection.style.display = "none";
        resultsSection.classList.remove("hidden");
        resultsSection.style.display = "block";

        window.scrollTo(0, 0);
      }
  
      if (calcBtn) {
        calcBtn.addEventListener("click", calculate);
      }
  
      if (editBtn && editBtn.dataset.hrdBound !== "true") {
        editBtn.dataset.hrdBound = "true";
        editBtn.addEventListener("click", () => {
          resultsSection.classList.add("hidden");
          resultsSection.style.display = "";
          inputsSection.style.display = "block";
        });
      }
  
      [addToCartTop, addToCartBottom].forEach((button) => {
        if (!button || button.dataset.hrdBound === "true") return;
  
        button.dataset.hrdBound = "true";
        button.addEventListener("click", () => {
            addVariantsToCart(selectedVariants, true)
        });
      });

      async function addVariantsToCart(items, redirect = false) {
        if (!Array.isArray(items) || items.length === 0) {
          throw new Error("items must be a non-empty array");
        }
      
        const payload = {
          items: items.map((item) => {
            const variantId = Number(item.id);
            const quantity = Number(item.qty ?? 1);
      
            if (!variantId || quantity <= 0) {
              throw new Error(
                `Invalid cart item: ${JSON.stringify(item)}`
              );
            }
      
            return {
              id: variantId,
              quantity,
            };
          }),
        };
      
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });
      
        const data = await response.json();
      
        if (!response.ok) {
          throw new Error(data.description || "Failed to add items to cart");
        }

        // Redirect to cart
        if (redirect)
          window.location.href = "/cart";
      
        return data;
      }
  
      // -----------------------------
      // PDF/General helpers
      // -----------------------------
  
      function skuFor(finishKey, part) {
        const m = PRODUCT_DATA[finishKey] || {};
        return m[part] && m[part].sku.trim() ? m[part].sku : "—";
      }
  
      function buildPreviewBody(quote) {
        const header = `
          <div class="doc-brand">
            <div class="doc-brand-bar">
              <img
                src="${LOGO_SRC}"
                alt="Handrails Direct"
                class="doc-brand-logo"
                crossOrigin="anonymous"
                onerror="this.style.display='none'"
              >
            </div>
          </div>
        `;
  
        const rows = [
          ["Poles", quote.materials.poles, skuFor(quote.finishKey, "poles"), "1200 mm each"],
          [
            "Support Brackets",
            quote.materials.supports,
            skuFor(quote.finishKey, "supports"),
            "Start/ends + elbows",
          ],
          ["Adjustable Elbows", quote.materials.elbows, skuFor(quote.finishKey, "elbows"), "For turns"],
          [
            "Connecting Brackets",
            quote.materials.connectors,
            skuFor(quote.finishKey, "connectors"),
            "Join poles",
          ],
          ["End Cap Packs", quote.materials.endcaps, skuFor(quote.finishKey, "endcaps"), "2 caps per pack"],
        ]
          .map(
            (r) =>
              `<tr><td>${r[0]}</td><td>${r[1]}</td><td>${r[2]}</td><td>${r[3]}</td></tr>`
          )
          .join("");
  
        return `
          ${header}
          <div class="report-title">Handrail Materials Report</div>
          <div class="report-sub">Generated: ${new Date().toLocaleString()}</div>
  
          <div class="pdf-h2">Project Summary</div>
          <table class="pdf-table summary-table" style="margin-bottom:12px">
            <colgroup>
              <col style="width:36%">
              <col style="width:64%">
            </colgroup>
            <tr><th>Total Length</th><td>${quote.total} mm</td></tr>
            <tr><th>Number of Turns</th><td>${quote.turns}</td></tr>
            <tr><th>Remaining</th><td>${quote.remaining} mm</td></tr>
            <tr><th>Finish</th><td>${quote.finish}</td></tr>
          </table>
  
          <div class="pdf-h2">Materials Required</div>
          <table class="pdf-table" style="margin-bottom:12px">
            <tr><th>Component</th><th>Quantity</th><th>SKU</th><th>Details</th></tr>
            ${rows}
          </table>
  
          <div style="font-size:11px;color:#6b7280;margin-top:18px;padding-bottom:20px;">
            All measurements in millimetres.
          </div>
        `;
      }
  
      function ensurePreview() {
        if (!lastQuote || !pdfDocEl) return false;
  
        if (!pdfDocEl.innerHTML || pdfDocEl.dataset.stale === "1") {
          pdfDocEl.innerHTML = buildPreviewBody(lastQuote);
          pdfDocEl.dataset.stale = "0";
        }
  
        return true;
      }
  
      function openPreview() {
        if (!lastQuote) {
          toast("Please calculate first");
          return;
        }
  
        if (!pdfPreviewEl) return;
  
        ensurePreview();
        pdfPreviewEl.classList.remove("hidden");
        pdfPreviewEl.classList.add("flex");
        pdfPreviewEl.setAttribute("aria-hidden", "false");
      }
  
      function closeModal() {
        if (!pdfPreviewEl) return;
  
        pdfPreviewEl.classList.add("hidden");
        pdfPreviewEl.classList.remove("flex");
        pdfPreviewEl.setAttribute("aria-hidden", "true");
      }
  
      if (savePdfBtn && savePdfBtn.dataset.hrdBound !== "true") {
        savePdfBtn.dataset.hrdBound = "true";
        savePdfBtn.addEventListener("click", savePdf);
      }
  
      if (downloadPdfBtn && downloadPdfBtn.dataset.hrdBound !== "true") {
        downloadPdfBtn.dataset.hrdBound = "true";
        downloadPdfBtn.addEventListener("click", openPreview);
      }
  
      if (closePreviewBtn && closePreviewBtn.dataset.hrdBound !== "true") {
        closePreviewBtn.dataset.hrdBound = "true";
        closePreviewBtn.addEventListener("click", closeModal);
      }

      // Download PDF
      async function savePdf() {
        if(!lastQuote){ toast('Please calculate first'); return; }

        if (typeof html2canvas !== 'function' || !window.jspdf || !window.jspdf.jsPDF) {
          console.error('PDF download failed: html2canvas or jsPDF did not load.');
          toast('Sorry, the PDF tool failed to load. Please check your connection and try again, or use Print instead.');
          return;
        }

        ensurePreview();

        // Create an off‑screen clone so the visible preview doesn't resize
        const clone = pdfDocEl.cloneNode(true);
        clone.classList.add('export-fit');
        Object.assign(clone.style, {
          position: 'fixed',
          left: '-10000px',
          top: '0',
          maxWidth: 'none',
          background: '#fff',
          zIndex: '-1'
        });
        document.body.appendChild(clone);

        try {
          await document.fonts?.ready;
          await new Promise(r=>requestAnimationFrame(r));

          const node = clone;
          const rect = node.getBoundingClientRect();
          const SCALE = Math.max(2, Math.min(3, window.devicePixelRatio || 2));
          const canvas = await html2canvas(node, {
            scale: SCALE,
            useCORS: true,
            backgroundColor: '#ffffff',
            width: Math.ceil(rect.width),
            height: Math.ceil(rect.height),
            windowWidth: Math.ceil(rect.width),
            windowHeight: Math.max(Math.ceil(rect.height), window.innerHeight)
          });

          const { jsPDF } = window.jspdf;
          const pdf = new jsPDF('p','mm','a4');
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const margin = 12; // mm (match print)
          const usableWidth = pageWidth - margin*2;
          const usableHeight = pageHeight - margin*2;

          const pxPerMM = canvas.width / usableWidth;
          const pageHeightPx = Math.floor(usableHeight * pxPerMM);

          let y = 0; let pageIndex = 0;
          while (y < canvas.height) {
            const sliceHeightPx = Math.min(pageHeightPx, canvas.height - y);

            const sliceCanvas = document.createElement('canvas');
            sliceCanvas.width = canvas.width;
            sliceCanvas.height = sliceHeightPx;
            const ctx = sliceCanvas.getContext('2d');
            ctx.drawImage(canvas, 0, y, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx);

            const imgData = sliceCanvas.toDataURL('image/png');
            const sliceHeightMM = sliceCanvas.height / pxPerMM;

            if (pageIndex > 0) pdf.addPage();
            pdf.addImage(imgData, 'PNG', margin, margin, usableWidth, sliceHeightMM, undefined, 'FAST');

            y += sliceHeightPx;
            pageIndex++;
          }

          pdf.save(`handrail-materials-report-${new Date().toISOString().slice(0,10)}.pdf`);
        } catch (err) {
          console.error('PDF download failed:', err);
          toast('Sorry, the PDF could not be created. Please use Print instead and choose "Save as PDF" in the print dialog.');
        } finally {
          // Cleanup hidden clone, even if generation failed partway through
          clone.remove();
        }
      }
  
      // PRINT 
      if (printPdfBtn && printPdfBtn.dataset.hrdBound !== "true") {
        printPdfBtn.dataset.hrdBound = "true";
        printPdfBtn.addEventListener("click", () => {
          if (!lastQuote) {
            toast("Please calculate first");
            return;
          }
  
          ensurePreview();
  
          const BB = "#1a3a4a";
          const html = buildPreviewBody(lastQuote);
  
          const doc = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8">
                <title>Handrail Report</title>
                <style>
                  @page { size:A4; margin:12mm }
                  html, body {
                    background:#fff;
                    -webkit-print-color-adjust:exact;
                    print-color-adjust:exact;
                  }
                  body {
                    margin:0;
                    font-family:system-ui,sans-serif;
                    color:${BB};
                  }
                  .pdf-document.export-fit {
                    width:calc(210mm - 24mm);
                    margin:0 auto;
                  }
                  .doc-brand {
                    border-radius:10px;
                    overflow:hidden;
                    margin:0 0 16px;
                  }
                  .doc-brand-bar {
                    background:${BB};
                    color:#fff;
                    display:flex;
                    align-items:center;
                    gap:12px;
                    padding:14px 16px;
                  }
                  .doc-brand-logo {
                    height:42px;
                    width:auto;
                    display:block;
                    object-fit:contain;
                  }
                  .report-title {
                    font-size:20px;
                    color:${BB};
                    font-weight:800;
                    text-align:center;
                    margin:6px 0 2px;
                  }
                  .report-sub {
                    color:#6b7280;
                    font-size:12px;
                    text-align:center;
                    margin-bottom:14px;
                  }
                  .pdf-h2 {
                    color:${BB};
                    font-weight:700;
                    margin:18px 0 8px;
                  }
                  .pdf-table {
                    width:100%;
                    border-collapse:collapse;
                  }
                  .pdf-table th {
                    background:#f6f2e7;
                    border:1px solid #c9a05a;
                    text-align:left;
                    padding:8px 10px;
                    color:${BB};
                  }
                  .pdf-table td {
                    border:1px solid #e8e0d0;
                    padding:8px 10px;
                  }
                  .pdf-table th:nth-child(2),
                  .pdf-table td:nth-child(2) {
                    text-align:right;
                    width:88px;
                  }
                  .pdf-table th:nth-child(3),
                  .pdf-table td:nth-child(3) {
                    white-space:nowrap;
                  }
                  .summary-table {
                    table-layout:fixed;
                  }
                  .summary-table th {
                    white-space:nowrap;
                    width:36%;
                  }
                  .summary-table td {
                    width:64%;
                  }
                  .summary-table th,
                  .summary-table td {
                    padding:6px 10px;
                  }
                </style>
              </head>
              <body>
                <div class="pdf-document export-fit">${html}</div>
                <script>
                  window.addEventListener('load', function () {
                    setTimeout(function () {
                      window.print();
                    }, 200);
  
                    window.addEventListener('afterprint', function () {
                      setTimeout(function () {
                        window.close();
                      }, 300);
                    });
                  });
                <\/script>
              </body>
            </html>
          `;
  
          const w = window.open("", "_blank");
          if (w && w.document) {
            w.document.open();
            w.document.write(doc);
            w.document.close();
          }
        });
      }
  
      // -----------------------------
      // Print staging support
      // -----------------------------
  
      if (!window.__HRD_BEFORE_PRINT_BOUND__) {
        window.__HRD_BEFORE_PRINT_BOUND__ = true;
  
        window.addEventListener("beforeprint", () => {
          const staging = getPrintStaging();
          const activePdfDoc = byId("pdfDocument");
  
          if (!staging || !activePdfDoc) return;
  
          if (activePdfDoc.innerHTML) {
            staging.innerHTML = "";
            const clone = activePdfDoc.cloneNode(true);
            clone.classList.add("export-fit");
            staging.appendChild(clone);
            staging.style.display = "block";
          }
        });
      }
  
      if (!window.__HRD_AFTER_PRINT_BOUND__) {
        window.__HRD_AFTER_PRINT_BOUND__ = true;
  
        window.addEventListener("afterprint", () => {
          const staging = getPrintStaging();
          if (!staging) return;
  
          staging.innerHTML = "";
          staging.style.display = "none";
        });
      }
    }
  
    function runInit() {
      initCalculator();
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runInit);
    } else {
      runInit();
    }
  
    // Shopify theme editor: sections can be re-rendered after initial page load.
    document.addEventListener("shopify:section:load", runInit);
  })();